import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useNavigate } from "react-router-dom";
import { useCentralStore } from "stores";

export const deleteRequisition = ({ churchId, requisitionId }) => {
  return axios.delete(`/churches/${churchId}/requisitions/${requisitionId}`);
};

export const useDeleteRequisition = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;
  const closeDeleteModal = useCentralStore.getState().closeDeleteModal;

  const navigate = useNavigate();

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(["requisitions"]);
      queryClient.invalidateQueries(["requisitions-paginated"]);

      setNotification({
        type: "success",
        message: "Requisition deleted successfully!"
      });
      closeDeleteModal();
      navigate("/finances/temp/expense/requisition", { replace: true });
    },
    ...config,
    mutationFn: deleteRequisition
  });
};
